import { memo } from 'react';

import { useValidationConfigStore } from '@/store';
import { DivProps } from '@/utils';

import { EmailNotificationConfiguration } from './EmailNotificationConfiguration';
import { HttpNotificationConfiguration } from './HttpNotificationConfiguration';

export type NotificationConfigurationProps = DivProps & {
  id: string;
};

const INotificationConfiguration = ({ id, ...rest }: NotificationConfigurationProps) => {
  const notification = useValidationConfigStore((state) => state.getNotification(id));

  switch (notification?.type) {
    case 'email':
      return <EmailNotificationConfiguration id={id} {...rest} />;
    case 'http':
      return <HttpNotificationConfiguration id={id} {...rest} />;
  }

  return null;
};

export const NotificationConfiguration = memo(INotificationConfiguration) as typeof INotificationConfiguration;
